import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Plan } from '@zipari/shared-sbp-models';

// Borrowed the types from the source code
declare type TrustedHTML = string & {
  __brand__: 'TrustedHTML';
};

declare type TrustedScript = string & {
  __brand__: 'TrustedScript';
};

declare type TrustedScriptURL = string & {
  __brand__: 'TrustedScriptURL';
};

declare type SanitizerFn = (
  value: any,
  tagName?: string,
  propName?: string,
) => string | TrustedHTML | TrustedScript | TrustedScriptURL;

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string | Plan, sanitizerType: keyof DomSanitizer) {
    const sanitizer =
      (this.sanitized[sanitizerType] as unknown as SanitizerFn) ||
      this.sanitized.bypassSecurityTrustHtml;

    return sanitizer(value as string);
  }
}
